import { render, staticRenderFns } from "./bindAliPay.vue?vue&type=template&id=22c4c265&scoped=true"
import script from "./bindAliPay.vue?vue&type=script&lang=js"
export * from "./bindAliPay.vue?vue&type=script&lang=js"
import style0 from "./bindAliPay.vue?vue&type=style&index=0&id=22c4c265&prod&lang=css"
import style1 from "./bindAliPay.vue?vue&type=style&index=1&id=22c4c265&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4c265",
  null
  
)

export default component.exports